import { render, staticRenderFns } from "./normalPortRequest.vue?vue&type=template&id=2cae8180&scoped=true&"
import script from "./normalPortRequest.vue?vue&type=script&lang=js&"
export * from "./normalPortRequest.vue?vue&type=script&lang=js&"
import style0 from "./normalPortRequest.vue?vue&type=style&index=0&id=2cae8180&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cae8180",
  null
  
)

export default component.exports